import { Bar, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

function chartData() {
	this.percentage = [...this.data];
	return this.percentage;
}

function renderBarChart() {
	const newLabels = this.labels;

	// Verificar si los datos son agrupados (array de arrays) o simples
	let datasets;

	if (Array.isArray(this.chartData) && Array.isArray(this.chartData[0])) {
		const colors = [
			// Azules
			'#1e3a8a',
			'#1d4ed8',
			'#2563eb',
			'#3b82f6',
			'#60a5fa',
			'#93c5fd',
			'#dbeafe',
			// Verdes
			'#14532d',
			'#15803d',
			'#16a34a',
			'#22c55e',
			'#4ade80',
			'#86efac',
			'#dcfce7',
			// Rojos
			'#7f1d1d',
			'#dc2626',
			'#ef4444',
			'#f87171',
			'#fca5a5',
			'#fecaca',
			'#fee2e2',
			// Amarillos/Naranjas
			'#92400e',
			'#d97706',
			'#f59e0b',
			'#fbbf24',
			'#fcd34d',
			'#fde68a',
			'#fef3c7',
			// Púrpuras
			'#581c87',
			'#7c3aed',
			'#8b5cf6',
			'#a78bfa',
			'#c4b5fd',
			'#ddd6fe',
			'#f3f4f6',
			// Rosas
			'#831843',
			'#be185d',
			'#e11d48',
			'#f43f5e',
			'#fb7185',
			'#fda4af',
			'#fecdd3',
			// Grises
			'#374151',
			'#4b5563',
			'#6b7280',
			'#9ca3af',
			'#d1d5db',
			'#e5e7eb',
			'#f9fafb',
			// Cian/Teal
			'#134e4a',
			'#0f766e',
			'#0d9488',
			'#14b8a6',
			'#5eead4',
			'#99f6e4',
			'#ccfbf1',
		];

		datasets = [];
		let colorIndex = 0;

		// Iterar sobre cada grupo de datos (cada subarray en chartData)
		for (let groupIndex = 0; groupIndex < this.chartData.length; groupIndex += 1) {
			const currentGroup = this.chartData[groupIndex];
			const currentLabels =
				this.seriesLabels && this.seriesLabels[groupIndex] ? this.seriesLabels[groupIndex] : [];

			// Iterar sobre cada serie dentro del grupo actual
			for (let seriesIndex = 0; seriesIndex < currentGroup.length; seriesIndex += 1) {
				const fullLabel = currentLabels[seriesIndex]
					? currentLabels[seriesIndex]
					: `Grupo ${groupIndex + 1} - Serie ${seriesIndex + 1}`;

				// Truncar etiqueta para la leyenda (máximo 20 caracteres)
				const truncatedLabel =
					fullLabel.length > 20 ? `${fullLabel.substring(0, 20)}...` : fullLabel;

				// Crear array de datos donde solo el grupo actual tiene valor
				// Usamos undefined en lugar de null o NaN para que Chart.js no dibuje espacios
				const dataArray = new Array(this.chartData.length);

				// Solo asignamos el valor si existe y es válido
				const value = currentGroup[seriesIndex];
				if (value !== null && value !== undefined && !Number.isNaN(value)) {
					dataArray[groupIndex] = value;
				}

				datasets.push({
					label: truncatedLabel,
					fullLabel, // Guardamos la etiqueta completa para el tooltip
					backgroundColor: colors[colorIndex % colors.length],
					data: dataArray,
					// Configuración para manejar valores nulos/NaN en Chart.js 2.7
					spanGaps: true,
				});

				colorIndex += 1;
			}
		}
	} else {
		// Datos simples: comportamiento original
		const newBackgroundColor = [...Array(this.chartData.length || 0)].map(() => '#5ed52b');

		// Filtrar valores nulos o NaN para evitar espacios en blanco
		const cleanData = [];
		if (this.chartData && this.chartData.length) {
			for (let i = 0; i < this.chartData.length; i += 1) {
				// Solo incluimos el valor si no es null, undefined o NaN
				if (
					this.chartData[i] !== null &&
					this.chartData[i] !== undefined &&
					!Number.isNaN(this.chartData[i])
				) {
					cleanData[i] = this.chartData[i];
				}
				// Si no, dejamos el índice sin definir (undefined)
			}
		}

		datasets = [
			{
				backgroundColor: newBackgroundColor,
				data: cleanData,
				// Configuración para manejar valores nulos/NaN en Chart.js 2.7
				spanGaps: true,
			},
		];
	}

	// Asegurarse de que las opciones incluyan spanGaps para manejar valores nulos
	const chartOptions = {
		...this.options,
		spanGaps: true, // Configuración global para manejar valores nulos/NaN
	};

	this.renderChart(
		{
			labels: newLabels,
			datasets,
		},
		chartOptions,
	);
}

function datachange() {
	/* eslint no-underscore-dangle: ["error", { "allow": ["_chart"] }] */
	this.$data._chart.destroy();
	this.renderBarChart();
}

function data() {
	return {
		percentage: [],
		newlabels: [],
	};
}

export default {
	extends: Bar,
	mixins: [reactiveProp],
	props: ['data', 'options', 'labels', 'seriesLabels'],
	data,
	mounted() {
		this.renderBarChart();
	},
	computed: {
		chartData,
	},
	methods: {
		renderBarChart,
	},
	watch: {
		data: datachange,
		options: {
			handler() {
				if (this.$data._chart) {
					this.$data._chart.destroy();
					this.renderBarChart();
				}
			},
			deep: true,
		},
	},
};



// WEBPACK FOOTER //
// ./src/components/shared/charts/BarChart.js